<div class="modal-header">
    <h3 class="modal-title text-uppercase">Ajouter une proposition</h3>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <i class="fas fa-times"></i>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="proposalForm" (ngSubmit)="onProposalFormSubmit()">
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <label for="date">Date*</label>
                    <input type="text"
                        id="date"
                        placeholder="Choisissez une date"
                        class="form-control"
                        formControlName="date"
                        name="date"
                        [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                        required
                        bsDatepicker
                        [minDate]="today"
                        autocomplete="off">
                    <ng-container *ngIf="proposalForm.get('date').invalid && (proposalForm.get('date').dirty || proposalForm.get('date').touched || proposalForm['submitted'])">
                        <small class="text-danger" *ngIf="proposalForm.get('date').errors.required">
                            La date est obligatoire
                        </small>
                    </ng-container>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <timepicker formControlName="time" name="time" [showMeridian]="false" [mousewheel]=""></timepicker>
                </div>
            </div>
        </div>
        <div class="form-group mt-10">
            <button type="submit" class="btn btn-primary w-100">Ajouter</button>
        </div>
    </form>
</div>
